import { z } from 'zod';
import { EnumUtils } from '@colonist/utils';
import { PlayerColor } from '../PlayerState.ts';
import { CardEnum } from '../CardState.ts';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { endGameResourceStateSchema } from './EndGameResourceState.ts';
import { endGameActivityStateSchema } from './EndGameActivityState.ts';
import { endGamePlayerStateSchema } from './EndGamePlayerState.ts';
import { validateState } from '../ValidateState.ts';
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const endGameStateSchema = z.object({
    // TODO: negative gameDurationInMS values exist in production data when using paused feature and abandon timer.
    gameDurationInMS: z.number().int(),
    totalTurnCount: z.number().int().nonnegative(),
    diceStats: z.array(z.number().int().nonnegative()),
    resourceCardsStats: z.array(z.enum(CardEnum)),
    developmentCardStats: z.array(z.enum(CardEnum)),
    resourceStats: createKeyRecordSchema(playerColorNumericKeys, endGameResourceStateSchema),
    activityStats: createKeyRecordSchema(playerColorNumericKeys, endGameActivityStateSchema),
    players: createKeyRecordSchema(playerColorNumericKeys, endGamePlayerStateSchema)
}).strict();
export function validateEndGameState(data) {
    return validateState(endGameStateSchema, data);
}
